// extracted by mini-css-extract-plugin
export var tech = "Techs-module--tech--RCsK5";
export var tech_svg = "Techs-module--tech_svg--ybK8L";